@if (iconSvg()) {
  <div
    class="svg-container d-flex"
    [innerHTML]="iconSvg()"
    [ngStyle]="{ width: sizeStyle(), height: sizeStyle(), color: color() }"
  ></div>
} @else {
  <div
    class="icon-placeholder"
    [ngStyle]="{ width: sizeStyle(), height: sizeStyle() }"
  ></div>
}
